
import { DialogueItem } from './types';
import { 
  cleanSectionContent, 
  removeDuplicateParagraphs, 
  deduplicateScriptureReferences, 
  deduplicateObjections 
} from '@/utils/responseFormatUtils';

export const formatInterfaithResponse = (item: DialogueItem): DialogueItem | null => {
  if (!item || !item.content || !item.content.response) {
    console.error("Invalid or empty interfaith dialogue item", item);
    return null;
  }

  const { faithGroup, question, response } = item.content;

  const cleanedItem: DialogueItem = {
    content: {
      faithGroup,
      question,
      response: {
        directAnswer: response.directAnswer ? removeDuplicateParagraphs(cleanSectionContent(response.directAnswer)) : '',
        biblicalFoundation: response.biblicalFoundation ? removeDuplicateParagraphs(cleanSectionContent(response.biblicalFoundation)) : '',
        comparisonOfBeliefs: response.comparisonOfBeliefs ? removeDuplicateParagraphs(cleanSectionContent(response.comparisonOfBeliefs)) : '',
        refutationFromTheirTexts: response.refutationFromTheirTexts ? removeDuplicateParagraphs(cleanSectionContent(response.refutationFromTheirTexts)) : '',
        theologicalReasoning: response.theologicalReasoning ? removeDuplicateParagraphs(cleanSectionContent(response.theologicalReasoning)) : '',
        finalAppeal: response.finalAppeal ? removeDuplicateParagraphs(cleanSectionContent(response.finalAppeal)) : '',
        scriptureReferences: deduplicateScriptureReferences(response.scriptureReferences || []),
        commonObjections: deduplicateObjections(response.commonObjections || [])
      }
    }
  };

  return cleanedItem;
};
